import React from 'react';

export const UsPrivacyPolicy: React.FC = () => {
  return (
    <p>
      By clicking &quot;Complete Order&quot;, you agree to our{' '}
      <a href="/terms" target="_blank">
        Terms of Use
      </a>{' '}
      and{' '}
      <a href="/privacy" target="_blank">
        Privacy Policy.
      </a>
    </p>
  );
};

export default UsPrivacyPolicy;
